export default () => ({
  variantData: null,
  currentVariantId: null,
  currentVariantAvailable: null,
  currentVariantTitle: null,
  productUrl: null,
  productImage: null,
  productTitle: null,
  section: null,
  addToCartText: null,
  addedToCartText: null,
  soldOutText: null,
  chooseSizeText: null,
  inStockText: null,
  fewLeftText: null,
  outOfStockText: null,
  fewLeftThreshold: 0,
  hasAvailableVariants: true,
  variantInventoryQuantity: 0,
  index: 1,
  loading: false,
  added: false,

  initVariants() {
    this.getVariantData();

    if (!this.currentVariantId) {
      this.currentVariantAvailable = false;
    }
  },

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(
        this.$refs[`variantPicker-${this.index}`].querySelector(
          '[type="application/json"]'
        ).textContent
      );
    return this.variantData;
  },

  updateOptions(select) {
    const option = select.options[select.selectedIndex];
    if (!option || !option.dataset.variantId) return;

    this.currentVariantId = option.dataset.variantId;
    this.currentVariantAvailable = option.dataset.variantAvailable === "true";
    this.currentVariantTitle = option.dataset.variantTitle || option.value;
    this.added = false;
  },

  selectVariant(input) {
    if (!input || !input.dataset.variantId) return;

    this.currentVariantId = input.dataset.variantId;
    this.currentVariantAvailable = input.dataset.variantAvailable === "true";
    this.currentVariantTitle = input.dataset.variantTitle || input.value;
    this.variantInventoryQuantity = Number(input.dataset.variantInventory || 0);
    this.added = false;
  },

  isFewLeft() {
    return (
      this.variantInventoryQuantity > 0 &&
      this.variantInventoryQuantity <= this.fewLeftThreshold
    );
  },

  stockClass() {
    if (!this.hasAvailableVariants) return "bg-red";
    if (!this.currentVariantId) return "bg-green";
    if (!this.currentVariantAvailable) return "bg-red";
    if (this.isFewLeft()) return "bg-orange";
    return "bg-green";
  },

  stockText() {
    if (!this.hasAvailableVariants) return this.outOfStockText;
    if (!this.currentVariantId) return this.inStockText;
    if (!this.currentVariantAvailable) return this.outOfStockText;
    if (this.isFewLeft()) return this.fewLeftText;
    return this.inStockText;
  },

  addProductToCart() {
    if (
      !this.currentVariantId ||
      !this.currentVariantAvailable ||
      this.loading ||
      this.added
    ) {
      return;
    }

    this.loading = true;

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(this.currentVariantId),
            quantity: 1,
          },
        ],
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Add to cart failed");
        }
        return response.json();
      })
      .then((response) => {
        this.added = true;
        this.$dispatch("cart-updated");

        const items = response.items || [response];
        if (typeof Tracking !== "undefined" && Array.isArray(items)) {
          items.forEach((item) => {
            const variant = Tracking.transformVariant(item);
            if (variant) {
              Tracking.addToCart(variant);
            }
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        this.$dispatch("cart-notice-error", false);
      })
      .finally(() => {
        this.loading = false;
      });
  },
});
